// extracted by mini-css-extract-plugin
export default {"spinner":"style_spinner__n+T3-","spinnerBlade":"style_spinnerBlade__fBNdy","spinner-fade":"style_spinner-fade__u4gDa"};